import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { TABLET_SCREEN_SIZE } from '@/constants';
import { AuthContext } from '@/contexts';

/**
 * Whether Layout shows the sidebar to a user without organization access (an uploader): on
 * desktop, when they have more than one ceremony, except on stream pages. The sidebar already has
 * the profile and logout, so pages with their own top bar hide it then.
 */
export const useIsUploaderSidebarShown = () => {
  const { currentUserData } = useContext(AuthContext);
  const pathName = useLocation().pathname;
  const [isTabletView, setIsTabletView] = useState(window.innerWidth < TABLET_SCREEN_SIZE);

  useEffect(() => {
    const handleResize = () => setIsTabletView(window.innerWidth < TABLET_SCREEN_SIZE);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    !isTabletView && (currentUserData?.events?.length ?? 0) > 1 && !pathName.includes('stream')
  );
};
